import { numberFormat } from "utils";
import { salaryDriverColNm } from "./constant";
import { IconButton } from "@mui/material";
import { ArticleRounded } from "resource/muiImport";
import dayjs from "dayjs";
import { jobOrderColNm } from "constants/jobOrderConstant";

export const columns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "DrvCd",
    headerName: "รหัสพนักงาน",
    width: 90,
  },
  {
    field: "DrvNm",
    headerName: "ชื่อ-นามสกุล",
    width: 180,
  },
  {
    field: "NumSts3",
    headerName: "เที่ยวส่ง",
    width: 70,
  },
  {
    field: "TripAllAmnt",
    headerName: salaryDriverColNm.TripAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "SalAmnt",
    headerName: salaryDriverColNm.SalAmnt,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt1",
    headerName: salaryDriverColNm.IncAmnt1,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt2",
    headerName: salaryDriverColNm.IncAmnt2,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt3",
    headerName: salaryDriverColNm.IncAmnt3,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt4",
    headerName: salaryDriverColNm.IncAmnt4,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt5",
    headerName: salaryDriverColNm.IncAmnt5,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "OthAmnt",
    headerName: salaryDriverColNm.OthAmnt,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "OthDscp",
    headerName: salaryDriverColNm.OthDscp,
    width: 100,
    editable: true,
  },
  {
    field: "TotalInc",
    headerName: salaryDriverColNm.TotalInc,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row: { SalAmnt, IncAmnt1, IncAmnt2, IncAmnt3, IncAmnt4, OthAmnt, TripAllAmnt, OTLSPayAmnt } }) =>
      +(SalAmnt || 0) + +(IncAmnt1 || 0) + +(IncAmnt2 || 0) + +(IncAmnt3 || 0) + +(IncAmnt4 || 0) 
      + +(OthAmnt || 0) + +(TripAllAmnt || 0),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DrvAdvPay",
    headerName: salaryDriverColNm.DrvAdvPay,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
  {
    field: "DeSSPrct",
    headerName: salaryDriverColNm.DeSSPrct,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
  {
    field: "DeSSAmnt",
    headerName: salaryDriverColNm.DeSSAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ value }) => Math.round(value),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSecDepAmnt",
    headerName: salaryDriverColNm.DeSecDepAmnt,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeTfcFineAmnt",
    headerName: salaryDriverColNm.DeTfcFineAmnt,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeAmnt1",
    headerName: salaryDriverColNm.DeAmnt1,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeAmnt2",
    headerName: salaryDriverColNm.DeAmnt2,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeAmnt3",
    headerName: salaryDriverColNm.DeAmnt3,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeOthAmnt",
    headerName: salaryDriverColNm.DeOthAmnt,
    width: 100,
    type: "number",
    align: "right",
    editable: true,
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeOthDscp",
    headerName: salaryDriverColNm.DeOthDscp,
    width: 150,
    editable: true,
  },
  {
    field: "TotalDeduc",
    headerName: salaryDriverColNm.TotalDedc,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row: { DrvAdvPay, DeSecDepAmnt, DeSSAmnt, DeOthAmnt, DeTfcFineAmnt
      , DeAmnt1, DeAmnt2, DeAmnt3, OTLSPayAmnt } }) => 
      +(DrvAdvPay || 0) + +(DeSecDepAmnt || 0) + +(DeSSAmnt || 0) + +(DeOthAmnt || 0) + +(DeTfcFineAmnt || 0) 
      + +(DeAmnt1 || 0) + +(DeAmnt2 || 0) + +(DeAmnt3 || 0) + +(OTLSPayAmnt || 0),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "GrndTotal",
    headerName: salaryDriverColNm.GrndTotal,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row: { TripAllAmnt, SalAmnt, IncAmnt1, IncAmnt2, IncAmnt3, IncAmnt4, OthAmnt
      , DrvAdvPay, DeSecDepAmnt, DeSSAmnt, DeOthAmnt, DeTfcFineAmnt, DeAmnt1, DeAmnt2
      , DeAmnt3 } }) => + (TripAllAmnt || 0)
      + +(SalAmnt || 0) + +(IncAmnt1 || 0) + +(IncAmnt2 || 0) + +(IncAmnt3 || 0) + +(IncAmnt4 || 0) + +(OthAmnt || 0)
      - (+(DrvAdvPay || 0) + +(DeSecDepAmnt || 0) + +(DeSSAmnt || 0) + +(DeOthAmnt || 0) + +(DeTfcFineAmnt || 0) 
        + +(DeAmnt1 || 0) + +(DeAmnt2 || 0) + +(DeAmnt3 || 0)),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุ",
    flex: 1,
    minWidth: 120,
  },
]

export const dirverSalaryMasterColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "DrvCd",
    headerName: "รหัส พขร.",
    width: 80,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 220,
  },
  {
    field: "SalAmnt",
    headerName: salaryDriverColNm.SalAmnt,
    width: 110,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "MobAmnt",
    headerName: salaryDriverColNm.MobAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "HousAmnt",
    headerName: salaryDriverColNm.HousAmnt,
    width: 110,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "LivAmnt",
    headerName: salaryDriverColNm.LivAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSSPrct",
    headerName: salaryDriverColNm.DeSSPrct,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
  {
    field: "DeLoanAmnt",
    headerName: salaryDriverColNm.DeLoanAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeElecAmnt",
    headerName: salaryDriverColNm.DeElecAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSecDepAmnt",
    headerName: salaryDriverColNm.DeSecDepAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeEduLoanAmnt",
    headerName: salaryDriverColNm.DeEduLoanAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
]



export const salaryDriverDetailColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 60,
    align: 'center',
    renderCell: ({id}) => {
      return id === 0? "": (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "JobOrdId",
    headerName: "เลขที่ใบงาน",
    width: 80,
  },
  {
    field: "LicNms",
    headerName: "ทะเบียนรถ",
    width: 80,
  },
  {
    field: "JOTm",
    headerName: "วันที่วิ่งงาน",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "ContNo",
    headerName: "หมายเลขตู้",
    width: 120,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    width: 60,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    minWidth: 220,
    valueGetter: ({id, row: {TakePlc, Loc, RtnPlc}}) =>id===0?"": `${TakePlc}-${Loc}-${RtnPlc}`,
    flex: 1,
  },
  {
    field: "ContStsNms",
    headerName: "หน้าที่",
    width: 80,
  },
  {
    field: "TripAmnt",
    headerName: "เบี้ยเลี้ยง",
    width: 70,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  // {
  //   field: "E14",
  //   headerName: "ค่า X-ray",
  //   width: 70,
  //   align: 'right',
  //   valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  // },
  // {
  //   field: "E1028",
  //   headerName: "ค่า เสียเวลา",
  //   width: 70,
  //   align: 'right',
  //   valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  // },
  // {
  //   field: "E86",
  //   headerName: "ค่า Lashing",
  //   width: 70,
  //   align: 'right',
  //   valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  // },
  // {
  //   field: "E88",
  //   headerName: "ค่า OT พขร",
  //   width: 70,
  //   align: 'right',
  //   valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  // },
  // {
  //   field: "Qty",
  //   headerName: "จำนวน",
  //   width: 70,
  // },
  // {
  //   field: "TotalTripAmnt",
  //   headerName: "รวมเบี้ยเลี้ยง",
  //   width: 100,
  //   align: 'right',
  //   valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  // },
  {
    field: "OthAmnt",
    headerName: "ค่าอื่นๆ",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "OthDscp",
    headerName: "รายละเอียดค่าอื่นๆ",
    minWidth: 150,
    flex: 1
  },
  {
    field: "ExpTotal",
    headerName: "รวม",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '0.00',
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุใบงาน",
    minWidth: 650,
    flex: 2
  },
]

export const salaryDriverDetailColumnsEnd = [
]